import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: 'onClick'
        }
    }

    onClick() {
        const id = this.getData('id')
        const platform = this.getData('platform')

        this.call('toggle', { id, platform }, 'ModalVideo')
    }
}
